const strings = {
  // API_ROUTE: "https://neotesting.online/cplasersoldering/testing/api",
  // PHOTO_URL: "https://neotesting.online/cplasersoldering/testing/public/uploads/profilephoto/"

  API_ROUTE: "https://testcplasersoldering.cplaser.in/api",
  PHOTO_URL: "https://testcplasersoldering.cplaser.in/public/uploads/profilephoto/"
};
export default strings;